// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__smtec","footerNav":"Footer_footerNav__YL8Lb","menu":"Footer_menu__Iah1N","link":"Footer_link__G0IpG"};